import React from 'react'
import { InputContainer } from 'modules/ui/atoms/Input/InputContainer'
import { TokenexContainer } from './tokenex.styled'
import { useTokenexContext } from './tokenex-context'
import Placeloader from 'modules/ui/atoms/Loaders/Placeloader'

export const TokenexCvcInput = ({ id }: { id: string }) => {
  const { isLoading, isCvvFocused, cvvError } = useTokenexContext()

  return (
    <InputContainer
      id={id}
      captionId="cvc-caption"
      value=""
      required
      label="Security code"
      error={cvvError}
    >
      <TokenexContainer id={id} errored={!!cvvError} focused={isCvvFocused} />
      {isLoading && (
        <Placeloader
          style={{
            width: '100%',
            height: '42px',
            position: 'absolute',
            top: 0,
            left: 0,
            borderRadius: 8,
          }}
        />
      )}
    </InputContainer>
  )
}
